import React from 'react';
import Grid from '@mui/material/Grid';
import ReportCard from './ReportCard';
import { useTheme } from '@mui/material/styles';
import icon from './Image/Icon.svg';
import icon1 from './Image/Icon3.svg';
import icon2 from './Image/Icon4.svg';
import icon3 from './Image/Icon5.svg';
import icon4 from './Image/Icon6.svg';

import './App.css';

function getCards(type, theme) {
  switch (type) {
    case 'Quickhits':
      return [
        {
          primary: "$200",
          secondary: "Action Required",
          day: "+5% from yesterday",
          color: theme.palette.secondary.main,
          iconPrimary: icon,
        },
        {
          primary: "145",
          secondary: "Health Checks",
          day: "+5% from yesterday",
          color: theme.palette.error.main,
          iconPrimary: icon1,
        },
        {
          primary: "290+",
          secondary: "Keep in Views",
          day: "+5% from yesterday",
          color: theme.palette.success.main,
          iconPrimary: icon2,
        },
        {
          primary: "500",
          secondary: "CM Tasks",
          day: "+5% from yesterday",
          color: theme.palette.primary.main,
          iconPrimary: icon3,
        },
        {
          primary: "500",
          secondary: "Total Tasks",
          day: "+5% from yesterday",
          color: theme.palette.primary.main,
          iconPrimary: icon4,
        },
      ];
       case 'client':
      return [
        {
          primary: "$200",
          secondary: "Active clients",
          day: "+5% from yesterday",
          color: theme.palette.secondary.main,
          iconPrimary: icon,
        },
        {
          primary: "145",
          secondary: "New Clients",
          day: "+5% from yesterday",
          color: theme.palette.error.main,
          iconPrimary: icon1,
        },
        {
          primary: "290+",
          secondary: "Lost Clients",
          day: "+5% from yesterday",
          color: theme.palette.success.main,
          iconPrimary: icon2,
        },
        {
          primary: "500",
          secondary: "Client Churn Rate",
          day: "+5% from yesterday",
          color: theme.palette.primary.main,
          iconPrimary: icon3,
        },
        {
          primary: "500",
          secondary: "Client Tenure",
          day: "+5% from yesterday",
          color: theme.palette.primary.main,
          iconPrimary: icon4,
        },
      ];
       case 'careManagement':
      return [
        {
          primary: "$200",
          secondary: "Task Due",
          day: "+5% from yesterday",
          color: theme.palette.secondary.main,
          iconPrimary: icon,
        },
        {
          primary: "145",
          secondary: "Tasks Completed",
          day: "+5% from yesterday",
          color: theme.palette.error.main,
          iconPrimary: icon1,
        },
        {
          primary: "290+",
          secondary: "Tasks Due ",
          day: "+5% from yesterday",
          color: theme.palette.success.main,
          iconPrimary: icon2,
        },
        {
          primary: "500",
          secondary: "Tasks Completed ",
          day: "+5% from yesterday",
          color: theme.palette.primary.main,
          iconPrimary: icon3,
        },
        {
          primary: "500",
          secondary: "Taks Past Due",
          day: "+5% from yesterday",
          color: theme.palette.primary.main,
          iconPrimary: icon4,
        },
      ];
       case 'carePartner':
      return [
        {
          primary: "$200",
          secondary: "Active Care Partners",
          day: "+5% from yesterday",
          color: theme.palette.secondary.main,
          iconPrimary: icon,
        },
        {
          primary: "145",
          secondary: "New Care Partners",
          day: "+5% from yesterday",
          color: theme.palette.error.main,
          iconPrimary: icon1,
        },
        {
          primary: "290+",
          secondary: "Care Partners Lost",
          day: "+5% from yesterday",
          color: theme.palette.success.main,
          iconPrimary: icon2,
        },
        {
          primary: "500",
          secondary: "Care Partner Churn Rate",
          day: "+5% from yesterday",
          color: theme.palette.primary.main,
          iconPrimary: icon3,
        },
        {
          primary: "500",
          secondary: "Care Partner Tenure",
          day: "+5% from yesterday",
          color: theme.palette.primary.main,
          iconPrimary: icon4,
        },
      ];
       case 'AwardManagement':
      return [
        {
          primary: "$200",
          secondary: "Awards Given", 
          day: "+5% from yesterday",
          color: theme.palette.secondary.main,
          iconPrimary: icon,
        },
        {
          primary: "145",
          secondary: "Shift Incentives",
          day: "+5% from yesterday",
          color: theme.palette.error.main,
          iconPrimary: icon1,
        },
        {
          primary: "290+",
          secondary: "Thankyou Awards",
          day: "+5% from yesterday",
          color: theme.palette.success.main,
          iconPrimary: icon2,
        },
        {
          primary: "500",
          secondary: "Award value",
          day: "+5% from yesterday",
          color: theme.palette.primary.main,
          iconPrimary: icon3,
        },
        {
          primary: "500",
          secondary: "Award value ",
          day: "+5% from yesterday",
          color: theme.palette.primary.main,
          iconPrimary: icon4,
        },
      ];
      case 'Applicant':
      return [
        {
          primary: "$200",
          secondary: "Front-End/Back-End ",
          day: "+5% from yesterday",
          color: theme.palette.secondary.main,
          iconPrimary: icon,
        },
        {
          primary: "145",
          secondary: "New Applicants",
          day: "+5% from yesterday",
          color: theme.palette.error.main,
          iconPrimary: icon1,
        },
        {
          primary: "290+",
          secondary: "Hired Applicants",
          day: "+5% from yesterday",
          color: theme.palette.success.main,
          iconPrimary: icon2,
        },
        {
          primary: "500",
          secondary: "Hiring Percantage",
          day: "+5% from yesterday",
          color: theme.palette.primary.main,
          iconPrimary: icon3,
        },
        {
          primary: "500",
          secondary: "Time to Hire",
          day: "+5% from yesterday",
          color: theme.palette.primary.main,
          iconPrimary: icon4,
        },
      ];
      
    case 'default':
    default:
      return [
        {
          primary: "$200",
          secondary: "All Earnings",
          day: "+5% from yesterday",
          color: theme.palette.secondary.main,
          iconPrimary: icon,
        },
        {
          primary: "145",
          secondary: "Orders",
          day: "+5% from yesterday",
          color: theme.palette.error.main,
          iconPrimary: icon1,
        },
        {
          primary: "290+",
          secondary: "Products",
          day: "+5% from yesterday",
          color: theme.palette.success.main,
          iconPrimary: icon2,
        },
        {
          primary: "500",
          secondary: "Customers",
          day: "+5% from yesterday",
          color: theme.palette.primary.main,
          iconPrimary: icon3,
        },
        {
          primary: "500",
          secondary: "Sales",
          day: "+5% from yesterday",
          color: theme.palette.primary.main,
          iconPrimary: icon4,
        },
      ];
  }
}

export default function Analytic({ type = 'default' }) {
  const theme = useTheme();
  const cards = getCards(type, theme);

  return (
    <>
      <Grid container spacing={3} className="okkk">
        {cards.map((card, idx) => (
          <Grid item xs={12} md={4} lg={3} sm={6} key={idx}>
            <ReportCard
              primary={card.primary}
              secondary={card.secondary}
              day={card.day}
              color={card.color}
              iconPrimary={card.iconPrimary}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
}